import script from "./DeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteModal.vue?vue&type=style&index=0&id=5ff9fe1c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff9fe1c"]])

export default __exports__